import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './redux'
import { BrowserRouter } from 'react-router-dom'

window.isDirectionRTL = window.isSSOEnabled === 'true'
window.hideFooter = window.isSSOEnabled === 'true'
window.isSSOEnabled = window.isSSOEnabled === 'true'
window.isAWebView = window.isAWebView === 'true'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        {/* <NavigateFunctionComponent /> */}
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
